import famlyPinLogo from 'root/public/img/famly-logos/Famly-Logomark-DarkBG.svg';
import famlyWhiteBgLogo from 'root/public/img/famly-logos/Famly-Logo-WhiteBG.svg';
import famlyPinPageLogo from 'root/public/img/famly-logos/Famly-Logo-DarkBG.svg';
import famlyWhiteBgMark from 'root/public/img/famly-logos/logo-sidebar-closed.svg';
import espiraLogo from 'root/public/img/espira/espira-logo.svg';
import kidoPinLogo from 'root/public/img/kido/kido-transparent.png';
import kidoWhiteBgLogo from 'root/public/img/kido/kido-blue.png';
import brightHorizonsPinLogo from 'root/public/img/bright-horizons/logo.svg';
import brightHorizonsWhiteBgLogo from 'root/public/img/bright-horizons/login-logo.svg';
import kindredPinLogo from 'root/public/img/kindred/logo-colored-bg.svg';
import kindredWhiteBgLogo from 'root/public/img/kindred/logo-white-bg.svg';
import nfamilyclubPinLogo from 'root/public/img/nfamilyclub/logo-colored-bg.svg';
import nfamilyclubWhiteBgLogo from 'root/public/img/nfamilyclub/logo-white-bg.svg';
import grandirukLogo from 'root/public/img/grandiruk/GrandirLogoMark-DarkBG.svg';
import nuffieldPinLogo from 'root/public/img/nuffieldhealth/NuffieldLogo-DarkBG.svg';
import nuffieldWhiteBgLogo from 'root/public/img/nuffieldhealth/NuffieldLogo-WhiteBG.svg';
import kinderzimmerukLogo from 'root/public/img/kinderzimmeruk/KinderzimmerUKLogoMark.svg';
import cpctreehouseLogo from 'root/public/img/cpc-treehouse/CpcTreehouseLogoMark.svg';
import cpcorchardsLogo from 'root/public/img/cpc-orchard/CpcOrchardLogoMark.svg';
import busybeesPinLogo from 'root/public/img/busybees/BusyBeesNavBarLogo.svg';
import busybeesWhiteBgLogo from 'root/public/img/busybees/BusyBeesLogo.svg';
import bbmontessoriPinLogo from 'root/public/img/bbmontessori/logo-colored-bg.svg';
import bbmontessoriWhiteBgLogo from 'root/public/img/bbmontessori/logo-white-bg.svg';
import bbodysseyPinLogo from 'root/public/img/bbodyssey/logo-tagline-dark-bg.svg';
import bbodysseyWhiteBgLogo from 'root/public/img/bbodyssey/logo-tagline-white-bg.svg';
import twizzletopsPinLogo from 'root/public/img/twizzletops/full-logo-dark.svg';
import twizzletopsWhiteBgLogo from 'root/public/img/twizzletops/full-logo-light.png';
import childbasePinLogo from 'root/public/img/childbase/full-logo-dark.png';
import childbaseWhiteBgLogo from 'root/public/img/childbase/full-logo-light.png';
import seymourHousePinLogo from 'root/public/img/seymourhouse/full-logo-light.svg';
import seymourHouseWhiteBgLogo from 'root/public/img/seymourhouse/full-logo-dark.svg';
import theoldstationnurseryPinLogo from 'root/public/img/theoldstationnursery/full-logo-light.svg';
import theoldstationnurseryWhiteBgLogo from 'root/public/img/theoldstationnursery/full-logo-dark.svg';
import nfamilyschoolPinLogo from 'root/public/img/nfamilyschool/full-logo-dark.svg';
import nfamilyschoolWhiteBgLogo from 'root/public/img/nfamilyschool/full-logo-light.svg';
/**
 * Statically imported logos for all whitelabels in the signin-app.
 * Static imports are required so webpack bundles the images — the signin-app
 * cannot access the public folder at runtime via URL paths.
 */
export const signinAppLogos = {
    famly: { pin: famlyPinLogo, whiteBg: famlyWhiteBgLogo, pinPage: famlyPinPageLogo, whiteBgMark: famlyWhiteBgMark },
    espira: { pin: espiraLogo, whiteBg: espiraLogo },
    kido: { pin: kidoPinLogo, whiteBg: kidoWhiteBgLogo },
    brighthorizons: { pin: brightHorizonsPinLogo, whiteBg: brightHorizonsWhiteBgLogo },
    kindred: { pin: kindredPinLogo, whiteBg: kindredWhiteBgLogo },
    nfamilyclub: { pin: nfamilyclubPinLogo, whiteBg: nfamilyclubWhiteBgLogo },
    grandiruk: { pin: grandirukLogo, whiteBg: grandirukLogo },
    nuffieldhealth: { pin: nuffieldPinLogo, whiteBg: nuffieldWhiteBgLogo },
    kinderzimmeruk: { pin: kinderzimmerukLogo, whiteBg: kinderzimmerukLogo },
    cpctreehouse: { pin: cpctreehouseLogo, whiteBg: cpctreehouseLogo },
    cpcorchards: { pin: cpcorchardsLogo, whiteBg: cpcorchardsLogo },
    busybees: { pin: busybeesPinLogo, whiteBg: busybeesWhiteBgLogo },
    bbmontessori: { pin: bbmontessoriPinLogo, whiteBg: bbmontessoriWhiteBgLogo },
    bbodyssey: { pin: bbodysseyPinLogo, whiteBg: bbodysseyWhiteBgLogo },
    twizzletops: { pin: twizzletopsPinLogo, whiteBg: twizzletopsWhiteBgLogo },
    childbase: { pin: childbasePinLogo, whiteBg: childbaseWhiteBgLogo },
    seymourhouse: { pin: seymourHousePinLogo, whiteBg: seymourHouseWhiteBgLogo },
    theoldstationnursery: { pin: theoldstationnurseryPinLogo, whiteBg: theoldstationnurseryWhiteBgLogo },
    nfamilyschool: { pin: nfamilyschoolPinLogo, whiteBg: nfamilyschoolWhiteBgLogo },
    // Deliberately the Famly marks: the test whitelabel is identified by its teal chrome, and
    // omitting it entirely would leave the logo slot blank on the pin and login screens.
    whitelabeltest: { pin: famlyPinLogo, whiteBg: famlyWhiteBgLogo },
};
